import config from '../config';
import { ApiFactoryClassType } from './factory';
import { ApiClass, ApiClassConstructor } from './types';

export type AuthApiClass = {
    login: (username: string, password: string) => Promise<any>;
    refreshToken: () => Promise<any>;
    resetPassword: (username: string) => Promise<any>;
};

const auth: ApiClassConstructor<AuthApiClass> = (
    factory: ApiFactoryClassType,
): ApiClass<AuthApiClass> => ({
    login: async (username: string, password: string) => {
        try {
            const params = new URLSearchParams({
                grant_type: 'password',
                client_id: config.clientId,
                username,
                password,
            });

            const response = await fetch(
                new URL('/token', factory.getApiHost()),
                {
                    method: 'POST',
                    body: params.toString(), // FIXME i think the toString is useless here. Typescript doesn't complain
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    mode: 'cors',
                },
            );

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    refreshToken: async () => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const params = new URLSearchParams({
                grant_type: 'refresh_token',
                client_id: config.clientId,
                refresh_token: session.auth.refresh_token ?? '', // required (null, undefined are not valid)
            });

            return await fetch(new URL('/token', factory.getApiHost()), {
                method: 'POST',
                body: params.toString(),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                mode: 'cors',
            });
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    resetPassword: async (username: string) => {
        try {
            const response = await fetch(
                new URL('/request-reset', factory.getApiHost()),
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        username,
                        client_id: config.clientId,
                    }),
                    mode: 'cors',
                },
            );

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
});

export default auth;
